<template>
  <div>
    <address-header :clientInfo="clientInfo" class="mb-3" />
    <lead-management-table  :card="card"
                            mode="quarterly"
                            :thresholds="MarginThresholds"
                            :year="year" />
    <header-line :title="$t('Webportal.CX.MonthlyConsideration')" />
    <lead-management-table  :card="card"
                            mode="monthly"
                            :thresholds="MarginThresholds"
                            :year="year" />
    <lead-management-legend :brand="brand"
                            :isJaguarMargin2023="isJaguarMargin2023"
                            :thresholds="MarginThresholds" />
  </div>
</template>

<script>
import AddressHeader from '@/components/CX/DashboardCards/AddressHeader.vue';
import HeaderLine from '@/components/CX/DashboardCards/HeaderLine.vue';
import LeadManagementLegend from '@/components/CX/DashboardCards/LeadManagementLegend.vue';
import LeadManagementTable from '@/components/CX/DashboardCards/LeadManagementTable.vue';

export default {
  components: {
    AddressHeader, HeaderLine, LeadManagementLegend, LeadManagementTable
  },

  props: {
    brand:              { type: String, required: true },
    card:               { type: Object,  default: undefined },
    clientInfo:         { type: Object,  default: undefined },
    isJaguarMargin2023: { type: Boolean, default: false },
    year:               { type: Number, required: true }
  },

  data() {
    return {
      MarginThresholds: [
         {
          Minimum: 80,
          Maximum: 100,
          Color: "#36C259",
          Smiley: 'grin',
          value: 1.0, 
          jag: 1.5,
          jag23: 1.0
        }, {
          Minimum: 60,
          Maximum: 79.99,
          Color: "#FFD900",
          Smiley: 'meh',
          value: 0.7, 
          jag: 1.2,
          jag23: 0.7
        }, {
          Minimum: 40,
          Maximum: 59.99,
          Color: "#FF6A00",
          value: 0.5, 
          jag: 1.0,
          jag23: 0.5
        }, {
          Minimum: 0,
          Maximum: 39.99,
          Color: "#f54052",
          Smiley: 'frown-open',
          value: 0.0, 
          jag: 0.0,
          jag23: 0.0
        }
      ],
    };
  }
}
</script>